import React       from "react"
import PriceInput  from "./price_input.js"
import AnnualTable from "./annual_table.js"

import { roundNumber } from "@react/quotes/form/helpers"

export default class AnnualPercentages extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      beginning_price : this.props.beginning_price,
      percentages     : this.props.percentages,
      checkboxes      : this.props.checkboxes,
      subscription    : this.props.subscription,
      interval        : this.props.interval,
      editable        : false
    }
    this.handleSubscriptionChange = this.handleSubscriptionChange.bind(this)
    this.handleIntervalChange     = this.handleIntervalChange.bind(this)
    this.handlePriceChange        = this.handlePriceChange.bind(this)
    this.handleMonthChange        = this.handleMonthChange.bind(this)
    this.handleCheckbox           = this.handleCheckbox.bind(this)
    this.checkAll                 = this.checkAll.bind(this)
  }

  // The lines hold the amount of a single invoice, this input the annual one.
  handlePriceChange(e) {
    const multiplier = this.state.subscription == this.props.yearly ? 1 / this.state.interval : 12
    this.setState({beginning_price : e.target.value * multiplier })
  }

  handleSubscriptionChange(e) {
    const subscription    = e.target.value
    const monthly         = subscription == this.props.monthly
    const multiplier      = monthly ? 12 * this.state.interval : 1 / 12
    const beginning_price = roundNumber(this.state.beginning_price * multiplier)
    this.setState({ subscription, beginning_price, interval: monthly ? 1 : this.state.interval })
  }

  handleIntervalChange(e) {
    const interval        = parseInt(e.target.value, 10)
    const beginning_price = roundNumber(this.state.beginning_price * this.state.interval / interval)
    this.setState({ interval, beginning_price })
  }

  handleMonthChange(index, value, event) {
    const percentages = this.state.percentages
    percentages[index] = value
    this.setState({ percentages })
  }

  handleCheckbox(index) {
    const checkboxes = this.state.checkboxes
    checkboxes[index] = !this.state.checkboxes[index]
    const percentages = this._recalculatePercentages(checkboxes)
    this.setState({ checkboxes, percentages })
  }

  checkAll(event) {
    const checked    = event.target.checked
    const checkboxes = this.state.checkboxes.map(checkbox => checked)
    const percentages = this._recalculatePercentages(checkboxes)
    this.setState({ percentages, checkboxes })
  }

  _recalculatePercentages(checkboxes) {
    let months = 0
    const newPercentages = []
    checkboxes.forEach(checkbox => checkbox ? months += 1 : null)
    const monthlyPartial = this._round(100 / months)
    return checkboxes.map(checkbox => checkbox ? monthlyPartial : 0)
  }

  _round(amount) {
    return Math.round(amount * 10000000) / 10000000
  }

  render () {
    return (
      <div>
        <div className="form-group">
          <label htmlFor="contract_invoice_monthly">
            {I18n.t("maintenance.contracts.subscription")}
          </label>

          <select
            className = "form-control"
            name      = "contract[subscription]"
            value     = {this.state.subscription}
            onChange  = {this.handleSubscriptionChange}
          >
            <option value={this.props.yearly}>{I18n.t("workorders.yearly")}</option>
            <option value={this.props.monthly}>{I18n.t("workorders.monthly")}</option>
          </select>
        </div>

        {this.state.subscription == this.props.yearly ?
          <div className="form-group">
            <label htmlFor="contract_invoicing_interval_years">
              {this.props.interval_label}
            </label>

            <select
              className = "form-control"
              id        = "contract_invoicing_interval_years"
              name      = "contract[invoicing_interval_years]"
              value     = {this.state.interval}
              onChange  = {this.handleIntervalChange}
            >
              {this.props.interval_options.map(option =>
                <option key={option.value} value={option.value}>{option.label}</option>
              )}
            </select>
          </div>
        :
          <input type="hidden" name="contract[invoicing_interval_years]" value={this.state.interval} />
        }

        <PriceInput
          value    = {this.state.beginning_price}
          onChange = {this.handlePriceChange}
        />

        <AnnualTable
          labels            = {this.props.labels}
          handleMonthChange = {this.handleMonthChange}
          price             = {this.state.beginning_price * this.state.interval}
          percentages       = {this.state.percentages}
          checkboxes        = {this.state.checkboxes}
          editable          = {this.state.editable}
          handleCheckbox    = {this.handleCheckbox}
          checkAll          = {this.checkAll}
          currency_symbol   = {this.props.currency_symbol}
        />
      </div>
    )
  }
}
